// import { WarningFilled } from '@ant-design/icons';
import { useMutation } from '@tanstack/react-query';
import { notification } from 'antd';
import { AxiosError } from 'axios';

import { queryClient } from '../../../App';
import { axiosInstance } from '../../../axios/axiosInstance';
import { UserAboutMe } from '../../model/classes/UserAboutMe';
import { key as UserSettingsDetails } from './useGetUserAboutMe';
import { key as UserDetails } from './useGetUserDetails';

interface PreferencesData {
  userId: number;
  payload: Omit<UserAboutMe, 'birthday'>;
}

interface ErrorResponse {
  message: string;
  errors: string[];
}

function transformErrorData(data: any): ErrorResponse {
  const result: ErrorResponse = {
    message: data.message,
    errors: []
  };

  if (data.errors)
    for (const [, value] of Object.entries(data.errors)) {
      // @ts-ignore
      result.errors.push(value[0]);
    }

  return result;
}
export const useUpdateUserData = () =>
  useMutation(
    async ({ userId, payload }: PreferencesData) => {
      const { data } = await axiosInstance.post(`api/profiles/${userId}`, {
        ...payload,
        version: 2,
        _method: 'PATCH'
      });
      return data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([UserDetails, UserSettingsDetails]);
        notification.success({ message: 'Update success' });
      },
      onError: (err: AxiosError) => {
        if (err.response) {
          const data = transformErrorData(err.response.data);
          notification.error({
            message: 'Update error ' + err.response?.status,
            description: data.errors.map((error: string) => {
              return (
                <p key={error} style={{ marginBottom: '5px' }}>
                  {error}
                </p>
              );
            })
          });
        }
      }
    }
  );
